import { render, staticRenderFns } from "./globalmonitor.vue?vue&type=template&id=60d8f806&"
import script from "./globalmonitor.vue?vue&type=script&lang=ts&"
export * from "./globalmonitor.vue?vue&type=script&lang=ts&"
import style0 from "./globalmonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports